// extracted by mini-css-extract-plugin
export var publications_search_section = "index-module--publications_search_section---RxyW";